import React, {FunctionComponent} from 'react';
import classNames from 'classnames';
import IconMasterCard from '../icon/IconMasterCard';
import IconVisa from '../icon/IconVisa';
import UILink from '../../ui/UILink';
import {reverse} from '../../urls';

type AttendeeRecordProps = {
  id: number
  name: string
  eventTitle: string
  date: string
  paid: boolean
  invoice: boolean
  amount?: string
  card?: {
    last4: string
    brand: string
  }
}

const AttendeeRecord: FunctionComponent<AttendeeRecordProps> = ({
  id,
  name,
  eventTitle,
  date,
  paid,
  invoice,
  amount,
  card,
}) => {
  const renderAmount = () => (
    <span className={classNames('text-base', {'text-green': paid, 'text-gray-dark': !paid})}>{amount}</span>
  );

  return (
    <div className="grid grid-cols-7 gap-x-2 pt-3 gap-y-1">
      <div className="col-span-4 text-base">
        <UILink href={`${reverse('attendees_detail', {id})}?ref=dashboard`}>{name}</UILink>
      </div>
      <div className="col-span-3 text-base text-right">
        {date}
      </div>
      {!amount &&
      <div className="col-span-4 text-xs text-gray-dark">
        {eventTitle}
      </div>
      }
      {amount &&
      <>
        <div className="col-span-4 text-xs text-gray-dark">
          {eventTitle}
        </div>
        <div className="col-span-3 text-right">
          {invoice &&
          (<>
            <span className="text-xs text-gray-dark">Invoice</span>&nbsp;
            {renderAmount()}
          </>)
          }
          {!invoice && card &&
          (
            <>
              <span className="text-xs text-gray-dark">
                {card.brand === 'master' && <IconMasterCard/>}
                {card.brand === 'visa' && <IconVisa/>}
                &nbsp;•• {card.last4}
              </span>&nbsp;
              {renderAmount()}
            </>)
          }
        </div>
      </>
      }
    </div>
  );
};

export default AttendeeRecord;
